export default __webpack_public_path__ + "static/media/design.7d58f711.jpg";